import React, {useContext, useRef, useState} from "react";
import {App, Button, Typography} from "antd";
import {AuthContext} from "../../Contexts/AuthContext";
import {useTranslation} from "react-i18next";
import {authorizationHeaders} from "../../api/authorization";

const StripeOfferPaymentAction = ({eventId, offerId}: {eventId: number; offerId: number}) => {
    const {auth} = useContext(AuthContext);
    const {modal} = App.useApp();
    const {t} = useTranslation();
    const [loading, setLoading] = useState(false);
    const busy = useRef(false);
    const showLink = async () => {
        if (busy.current) return;
        busy.current = true; setLoading(true);
        try {
            const response = await fetch(`/api/events/${eventId}/offers/${offerId}/stripe-payment-link`, {method: "POST", credentials: "include", headers: authorizationHeaders(auth.token)});
            if (!response.ok) throw new Error();
            const {paymentUrl} = await response.json();
            modal.info({title: t("stripe-payment-link"), content: <div>
                <Typography.Paragraph>{t("stripe-payment-link-help")}</Typography.Paragraph>
                <Typography.Paragraph copyable={{text: paymentUrl}}>
                    <a href={paymentUrl} target="_blank" rel="noreferrer">{t("stripe-open-payment")}</a>
                </Typography.Paragraph>
            </div>});
        } catch {modal.error({title: t("stripe-payment-unavailable"), content: t("stripe-payment-unavailable-help")});}
        finally {busy.current = false; setLoading(false);}
    };
    return <Button size="small" loading={loading} onClick={() => void showLink()}>{t("stripe-payment-link")}</Button>;
};
export default StripeOfferPaymentAction;
